// src/context/UserContext.tsx
// نام فایل: UserContext.tsx

import React, { createContext, useContext, useState, useEffect } from "react";

interface User {
  username: string;
  displayName: string;
}

interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUserState] = useState<User | null>(null);

  // خواندن از localStorage در بارگذاری اولیه
  useEffect(() => {
    const username = localStorage.getItem("username");
    const displayName = localStorage.getItem("displayName");
    if (username && displayName) {
      setUserState({ username, displayName });
    }
  }, []);

  // ذخیره در localStorage هر بار که تغییر کرد
  const setUser = (newUser: User | null) => {
    setUserState(newUser);
    if (newUser) {
      localStorage.setItem("username", newUser.username);
      localStorage.setItem("displayName", newUser.displayName);
    } else {
      localStorage.removeItem("username");
      localStorage.removeItem("displayName");
    }
  };

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// هوک برای استفاده راحت‌تر
export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser باید داخل UserProvider استفاده شود");
  }
  return context;
}
